import './team-access-modal.scss';

export * from './team-access-modal';
